import React,{useContext} from "react";
import { CUSTOM_STYLES, CXR_SUBTABS_ID, CXR_TABS, CXR_TABS_ALLOWED_ROLES, PEER_REVIEW_SUBTABS_ID, PEER_REVIEW_TABS, PEER_REVIEW_TABS_ALLOWED_ROLES, USERTYPES } from "../../../../constants/Constants";
import studylistContext from "../../../../context/studylist/StudylistContext";
import { Pivot, PivotItem } from '@fluentui/react';
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import userContext from "../../../../context/users/UserContext";

const PeerReviewTabs = () => {

    const {
        roles,
        selectedValue,
        handlePeerReviewTabChange,

      } = useContext(studylistContext);
    const { getThemeColor } = useContext(themeContext);
    const {userId ,contextSwitchUser, isActiveData, peerReviewAdmin, peerReviewEvaluator,} = useContext(userContext);
    const loadSelectedXrayTab = (item)=>{
        console.log("-----Peer Review------", item);
       if(item.props.itemKey === 'reviewAssigned'){
        handlePeerReviewTabChange(item.props.itemKey, PEER_REVIEW_TABS.reviewAssigned, "study_14")
       }else if(item.props.itemKey === 'reviewComplete'){
        handlePeerReviewTabChange(item.props.itemKey, PEER_REVIEW_TABS.reviewComplete, "study_15")
       }else if(item.props.itemKey === 'evaluationAssigned'){
        handlePeerReviewTabChange(item.props.itemKey, PEER_REVIEW_TABS.evaluationAssigned, "study_16")
       }else if(item.props.itemKey === 'evaluationComplete'){
        handlePeerReviewTabChange(item.props.itemKey, PEER_REVIEW_TABS.evaluationComplete, "study_17")
       }
     }

     const getDefaultTab = () => {
      if (selectedValue=="study_14") {
        return "reviewAssigned";
      }
      if (selectedValue=="study_15") {
        return "reviewComplete";
      }
      if (selectedValue=="study_16") {
        return "evaluationAssigned";
      }
      if (selectedValue=="study_17") {
        return "evaluationComplete";
      }
      return null; // Default case
    };

    return (
        <>
        { (PEER_REVIEW_SUBTABS_ID.includes(selectedValue) && PEER_REVIEW_TABS_ALLOWED_ROLES.includes(roles[0])) && (
             <>
               <div style={{position : "relative", 
               borderLeft: getThemeColor("border"), 
               borderTop: getThemeColor("border")
               }} className="xray-tabs-pivot-top">
                <div className="study-list-hide-cxr-border-top"></div>
                <Pivot  className="xray-tabs-pivot"
                aria-label="Xray tabs"
                linkSize="small"
                linkFormat={'tabs'}
                defaultSelectedKey={getDefaultTab()}
                onLinkClick={(item) => loadSelectedXrayTab(item)}
                >
                  {!peerReviewEvaluator && (peerReviewAdmin || roles[0] == USERTYPES.RADIOLOGIST)  && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.review-assigned")}>{t("study-list.tabs.review-assigned")} </CustomToolTipHost>} itemKey="reviewAssigned"></PivotItem>
                  }
                  {!peerReviewEvaluator && (peerReviewAdmin || roles[0] == USERTYPES.RADIOLOGIST) && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.review-complete")}> {t("study-list.tabs.review-complete")}</CustomToolTipHost>} itemKey="reviewComplete"> </PivotItem>
                  }
                  {roles[0] != USERTYPES.RADIOLOGIST && (peerReviewAdmin || peerReviewEvaluator) && 
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.evaluation-assigned")}> {t("study-list.tabs.evaluation-assigned")}</CustomToolTipHost>} itemKey="evaluationAssigned"></PivotItem>
                  }
                  {roles[0] != USERTYPES.RADIOLOGIST && (peerReviewAdmin || peerReviewEvaluator) &&
                    <PivotItem headerText={<CustomToolTipHost content={t("study-list.cxr-tooltip.evaluation-complete")}> { t("study-list.tabs.evaluation-complete")}</CustomToolTipHost>} itemKey="evaluationComplete"></PivotItem>
                  }
                </Pivot>
              </div>
             </>
            )}
        </>
    )
}

export default PeerReviewTabs;